import service from "../services/VirtualUserService";
import { NabpRole, ExternalIdentifiers } from "@p1s/p1s-common-react/entities";
import { sortByField } from "@p1s/p1s-common-react/utilities/SortingUtilities";

const setEmailTicket = "SetEmail";
class VirtualUserApi {
    updateCurrentUser (user) {
        const request = {
            VirtualUserId: user.id,
            FirstName: user.firstName,
            LastName: user.lastName
        };

        return new Promise((resolve, reject) => {
            service.updateCurrentUser(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    verifyUserEmail (userId, newEmail) {
        const request = {
            VirtualUserId: userId,
            Email: newEmail
        };
        return new Promise((resolve, reject) => {
            service.verifyUserEmail(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    discardEmailChanges (userId) {
        const request = {
            VirtualUserId: userId,
            VirtualUserTicketType: setEmailTicket
        };

        return new Promise((resolve, reject) => {
            service.clearVirtualUserTickets(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    getVirtualUsersByOrgId (orgId, virtualProductId, filterByAssignedOrganizationId) {
        const request = {
            OrgId: orgId,
            ExcludeInactive: true,
            FilterByVirtualProductId: virtualProductId,
            FilterByAssignedOrganizationId: filterByAssignedOrganizationId
        };

        return new Promise((resolve, reject) => {
            service.getVirtualUsersByOrgId(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    async checkExternalIdsUniqueness (organizationId, externalIdentifiers) {
        const request = {
            OrgId: organizationId,
            ExternalIdentifiers: externalIdentifiers
        };
        const res = await service.checkExternalIdsUniqueness(request);

        return res.data;
    }

    async updateExternalIds (userId, externalIdentifiers) {
        const request = {
            VirtualUserId: userId,
            NationalProviderIdentifier: externalIdentifiers?.nationalProviderIdentifier,
            NabpEPid: externalIdentifiers?.nabpEPid,
            DateOfBirth: externalIdentifiers?.dateOfBirth,
            NabpRoleId: externalIdentifiers?.nabpRoleId
        };
        const res = await service.updateExternalIds(request);

        return new ExternalIdentifiers(res.data);
    }

    async getNabpRoles () {
        const res = await service.getNabpRoles();
        return mapToNabpRolesItems(res.data);
    }
}
const mapToNabpRolesItems = (json) => {
    if (json) {
        return json.map(r => new NabpRole(r)).sort((a, b) => sortByField(a, b, "asc", "rank"));
    }
};

export default new VirtualUserApi();
